import { render, staticRenderFns } from "./BmCodeIndex.vue?vue&type=template&id=2512615b&scoped=true&"
import script from "./BmCodeIndex.vue?vue&type=script&lang=js&"
export * from "./BmCodeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2512615b",
  null
  
)

export default component.exports